var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical"},[_c('div',{staticClass:"progress",class:_vm.size},[_c('div',{ref:"progressBar",staticClass:"progress-bar",style:('height: ' + _vm.value + '%')})]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.animatedValue + '%'))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675c4cbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestic-components/vuestic-progress-bar/progress-types/VerticalProgressBar.vue
// module id = QzAA
// module chunks = 41